import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { ChevronRight } from 'lucide-react';
interface Slide2Props {
  onNavigate: (slide: number) => void;
  onBack: () => void;
}
export function Slide2({
  onNavigate,
  onBack
}: Slide2Props) {
  const menuItems = [{
    title: 'TREATMENT OVERVIEW',
    slide: 4
  }, {
    title: 'MODE OF ACTION',
    slide: 12
  }, {
    title: 'CLINICAL USE',
    slide: 13
  }, {
    title: 'ADDITIONAL RESOURCES',
    slide: 7
  }];
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." onBack={onBack} data-id="element-125">
      <div className="w-full max-w-6xl mx-auto space-y-12" data-id="element-126">
        {/* Header */}
        <h2 className="text-4xl font-bold text-white text-center uppercase tracking-wide drop-shadow-sm" data-id="element-127">
          EXPLORE THE DUAL-TARGET APPROACH
        </h2>

        {/* Menu Grid */}
        <div className="grid grid-cols-2 gap-8" data-id="element-128">
          {menuItems.map((item, index) => <button key={index} onClick={() => onNavigate(item.slide)} className="frosted-card rounded-2xl p-8 hover:bg-white/25 transition-all duration-300 hover:shadow-xl group flex items-center justify-between h-32" data-id="element-129">
              <span className="text-2xl font-bold text-[#1B3A5C] italic tracking-wide text-left" data-id="element-130">
                {item.title}
              </span>
              <div className="w-12 h-12 flex items-center justify-center" data-id="element-131">
                <ChevronRight className="w-10 h-10 text-[#6B46C1] stroke-[3]" data-id="element-132" />
              </div>
            </button>)}
        </div>

        {/* Patient Profile */}
        <div className="text-center mt-8" data-id="element-133">
          <p className="text-lg text-highlight font-bold italic" data-id="element-134">
            PATIENT PROFILE: VABYSMO® IS INDICATED FOR THE TREATMENT OF nAMD,
            DMO, & RVO.¹
          </p>
        </div>
      </div>
    </SlideLayout>;
}